module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0120.jpg?v=1ab269c4";